export enum TreatAction{
	VALIDATE = 'VALIDATE',
	PUBLISH_REOPEN = 'PUBLISH_REOPEN',
	DELETE = 'DELETE',
	DPIA_COMMENT = 'DPIA_COMMENT',
	EDIT_CHAPTER_TREAT = 'EDIT_CHAPTER_TREAT',
	EDIT_CHAPTER_CHECK_RA_DPIA = 'EDIT_CHAPTER_CHECK_RA_DPIA',
	EDIT_CHAPTER_LIA = 'EDIT_CHAPTER_LIA',
	SNAPSHOT = 'SNAPSHOT',
	OBSOLETE = 'OBSOLETE',
	EDIT_CHAPTER_CUSTOM = 'EDIT_CHAPTER_CUSTOM',
}
